import React from 'react';
import { useTranslation } from '@app/core/i18n';

import classNames from 'classnames';

import { uniqueId } from '@ast/magma/inner/utils/uniqueid';

import { AccountCard } from '@app/common/components/AccountCard';

import styles from './styles.pcss';

export const AccountsDropDownEmpty: React.FC = () => {
  const { t } = useTranslation();

  const ariaLabelId = React.useMemo(() => uniqueId('accounts-dropdown-no-items-label'), []);

  return (
    <>
      <button
        aria-labelledby={ariaLabelId}
        className={classNames(styles.item, styles.empty)}
        data-stable-name="AccountsDropDownNoItems"
        tabIndex={-1}
        type="button"
      >
        <AccountCard
          contentBefore={(
            <span
              id={ariaLabelId}
            >
              {t(
                'accounts-dropdown.empty.title|Default title for empty dropdown',
                'No available items to display',
              )}
            </span>
          )}
          className={styles.emptyGroup}
        />
      </button>
    </>
  );
};
